@file:OptIn(ExperimentalJsExport::class)

package co.diena.everything.app.worker

import co.diena.everything.api.Bucket
import co.diena.everything.api.EntityId
import co.diena.everything.api.EverythingEvent
import co.diena.everything.api.ResolvedCategory
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.StateFlow
import kotlinx.serialization.Serializable
import org.lortex.lines.common.AnyError
import org.lortex.lines.common.AnyResult
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport

@Serializable
sealed class LoaderError {
    @Serializable
    data object UnknownError : LoaderError()

    @Serializable
    data class NetworkError(val retryInSeconds: Int) : LoaderError()
}

interface EventLoader {
    val events: StateFlow<Map<EntityId, EverythingEvent>>

    val pendingBucketsCount: StateFlow<Int>
    val pendingEntitiesCount: StateFlow<Int>

    val currentCategory: StateFlow<EntityId?>
    val availableCategories: StateFlow<List<ResolvedCategory>>

    val error: StateFlow<LoaderError?>

    suspend fun setCategory(category: EntityId?)

    suspend fun loadEvents(
        coroutineScope: CoroutineScope,
        buckets: List<Bucket>,
    )

    // -- not strictly event loading but heh
    suspend fun subscribeToNewsletter(email: String): AnyResult<Unit>

    suspend fun analyticsEvent(entityId: EntityId)
}